import { put, takeLatest } from "redux-saga/effects";
import { translation } from "Helpers/i8n-helper";
import {
  loginSubmit,
  loginSuccess,
  loginError,
  getUserRequest,
  getUserSuccess,
  getUserError,
  getDwollaBalanceRequest,
  getDwollaBalanceSuccess,
  getDwollaBalanceError,
  oAuthLoginSubmit,
  oAuthLoginSuccess,
  oAuthLoginError
} from "../reducers/AuthReducer";
import { addItem } from "Service/storage-service";
import APP_CONSTANTS from "Constants/app-constants";
import { signin, getUser, getDwollaBalance, oauthRegisterLogin } from "../../services/auth";
import axios from "../../services/api-client";

const t = translation("error");

function* LoginSubmit(action) {
  try {
    const response = yield signin(action.payload);
    if (response?.success) {
      addItem(APP_CONSTANTS.ACCESS_TOKEN, JSON.stringify(response?.userApiAccessToken));
      axios.defaults.headers.common['Authorization'] = `Bearer ${response?.userApiAccessToken}`;
      yield put(loginSuccess(response));
    } else {
      yield put(loginError(response?.message || t("errorOccurred")));
    }
  } catch (e) {
    console.log("CATCH", e);
    yield put(loginError(e));
  }
}

function* OAuthRegisterLogin({ payload }) {
  try {
    let data = undefined;
    if (payload?.appleIdentityToken) {
      data = {
        appleIdentityToken: payload?.appleIdentityToken,
        registrationPlatform: "web"
      };
    } else {
      data = {
        email: payload?.email,
        username: payload?.givenName,
        picture: {
          _id: false,
          url: payload?.photo || "",
          public_id: ""
        },
        registrationPlatform: "web"
      };
    }
    const response = yield oauthRegisterLogin(data);
    if (response?.success) {
      addItem(APP_CONSTANTS.ACCESS_TOKEN, JSON.stringify(response?.userApiAccessToken));
      axios.defaults.headers.common['Authorization'] = `Bearer ${response?.userApiAccessToken}`;
      yield put(oAuthLoginSuccess(response));
    } else {
      yield put(oAuthLoginError(response?.message || t("errorOccurred")));
    }
  } catch (e) {
    console.log("CATCH", e);
    yield put(oAuthLoginError(e));
  }
}

function* GetUser() {
  try {
    const response = yield getUser();
    if (response.success) {
      yield put(getUserSuccess(response));
    } else {
      yield put(getUserError(t("errorOccurred")));
    }
  } catch (e) {
    yield put(getUserError(e));
  }
}

function* GetDwollaBalance(action) {
  try {
    const response = yield getDwollaBalance(action.payload);
    if (response.success) {
      yield put(getDwollaBalanceSuccess(response));
    } else {
      yield put(getDwollaBalanceError(t("errorOccurred")));
    }
  } catch (e) {
    yield put(getDwollaBalanceError(e));
  }
}

function* AuthSaga() {
  yield takeLatest(loginSubmit.type, LoginSubmit);
  yield takeLatest(oAuthLoginSubmit.type, OAuthRegisterLogin);
  yield takeLatest(getUserRequest.type, GetUser);
  yield takeLatest(getDwollaBalanceRequest.type, GetDwollaBalance);
}

export default AuthSaga;
